import type { ReactNode } from "react";
import { AdsHelpHint } from "@/components/ads-assistant/AdsAssistantCollapsible";

export function adsFeedImportLabelWithHint(label: string, hintLabel: string, children: ReactNode) {
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      {label}
      <AdsHelpHint label={hintLabel}>{children}</AdsHelpHint>
    </span>
  );
}
